"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetSelectedSimilarProductsUseCase = void 0;
const react_1 = require("react");
const similarProducts_1 = require("../../repositories/similarProducts");
/**
 * Caso de uso que obtém os produtos similares selecionados pelo CF.
 */
function useGetSelectedSimilarProductsUseCase() {
    const similarProductsRepository = (0, react_1.useMemo)(() => new similarProducts_1.SimilarProductsRepository(), []);
    const [result, setResult] = (0, react_1.useState)({});
    const call = (0, react_1.useCallback)((skus) => __awaiter(this, void 0, void 0, function* () {
        const data = similarProductsRepository.getAll();
        const filteredData = filterBySkus(data, skus);
        setResult(filteredData);
        return filteredData;
    }), []);
    return [result, call];
}
exports.useGetSelectedSimilarProductsUseCase = useGetSelectedSimilarProductsUseCase;
function filterBySkus(selectedSimilarProducts, skus) {
    return Object.entries(selectedSimilarProducts)
        .filter(([sku]) => skus.includes(sku))
        .reduce((acc, [sku, value]) => (Object.assign(Object.assign({}, acc), { [sku]: value })), {});
}
